import { type IConversions } from "./IConversions";

/*
 * A conversion that invokes a callback to determine the data used to display a list item.
 */
export class CallableConversions<S extends string | number, T> implements IConversions<S, T> {
	private conversion: ((key: S) => T);

	constructor(conversion: ((key: S) => T)) {
		this.conversion = conversion;
	}

	data(key: S): T {
		return this.conversion(key);
	}

	load() {
		return Promise.resolve();
	}

	invalidate(): Promise<void> {
		throw Error("a CallableConversion cannot explicitly invalidate its entries, they might invalidate implicitly when the underlying data change but are otherwise fixed");
	}

	get isResetting(): number {
		return 0;
	}
}
